import { Button } from "@/shadcn/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/shadcn/components/ui/dialog";
import React from "react";

type ForgotPasswordDialogProps = {
  goToMagicLink: () => void;
};

const ForgotPasswordDialog: React.FC<ForgotPasswordDialogProps> = ({
  goToMagicLink,
}) => {
  return (
    <Dialog modal={true}>
      {/* The trigger button is rendered as provided by the parent */}
      <DialogTrigger asChild>
        <Button variant="link">Forgot Password?</Button>
      </DialogTrigger>

      <DialogContent>
        <DialogTitle className="text-center">Forgot Your Password?</DialogTitle>
        {/* Step-by-step instructions help users understand the process and reduce support burden */}
        <div>
          <span className="font-bold">No problem!</span> To regain access to
          your account, please follow these steps:
        </div>
        <ol className="list-decimal pl-6">
          <li>
            Click the “<span className="font-bold">Login with MagicLink</span>”
            button below.
          </li>
          <li>Enter your registered email address.</li>
          <li>
            Check your inbox for an email from Vulcan Steel with a secure
            MagicLink.
          </li>
          <li>
            Click the link in the email to log in instantly—no password needed.
          </li>
          <li>
            Once you are logged in, go to your{" "}
            <span className="font-bold">Profile</span> page.
          </li>
          <li>
            From your profile, choose “
            <span className="font-bold">Change Password</span>” to set a new
            password.
          </li>
        </ol>
        <div>
          If you don't receive the email within a few minutes, please check your
          spam or junk folder.
        </div>
        {/* Security note is included to set user expectations and prevent confusion */}
        <div>
          <span className="font-bold">Note:</span> For your security, password
          resets can only be done after logging in using MagicLink.
        </div>
        {/* The button directs users to the MagicLink login flow to ensure a secure reset process */}
        <Button variant="default" onClick={goToMagicLink} className="m-auto">
          Login with MagicLink
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ForgotPasswordDialog;
